<template>
<v-card>
  <v-list three-line class="px-0 py-0">
    <v-list-tile avatar @click="$emit('click',tracker)">
      <device-avatar :item="tracker.deviceInfo" :eventlog="eventlog"></device-avatar>
      <v-list-tile-content>
        <v-list-tile-title class="brown--text">{{ tracker.name }}</v-list-tile-title>
        <v-list-tile-sub-title v-html="content"></v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import DeviceAvatar from '@/components/device/DeviceAvatar'
const categoryLabels = require('../device/DeviceLabels');

export default {
  name: 'TrackerItem',
  props: {
    tracker: {
      type: Object,
      required: true
    },
    eventlog: {
      type: Object,
      required: true
    }
  },
  components: {
    'device-avatar': DeviceAvatar
  },
  computed: {
    content() {
      return this.$t('tracker.after_minutes_should_be', {
        target: `<b>${this.tracker.deviceInfo.targetName||this.tracker.deviceInfo.name}</b>`,
        minutes: `<b>${this.tracker.pending}</b>`,
        value: `<span class='primary--text'>${this.valueShould}</span>`
      })
    },
    valueShould() {
      if (this.isSwitchShown) return `<b>${this.statusSwitch ? this.$t(this.statusSwitch) : '---'}</b>`;
      if (this.isLockShown) return `<b>${this.statusLock ? this.$t(this.statusLock) : '---'}</b>`;
      return '<b>---</b>';
    },
    isSwitchShown() {
      return [23, 36].includes(this.tracker.deviceInfo.ctrltype) && this.eventlog.basicvalue != undefined;
    },
    statusSwitch() {
      return categoryLabels[23][this.tracker.value > 0 ? 100 : 0];
    },
    isLockShown() {
      return this.tracker.deviceInfo.ctrltype == 31 && this.eventlog.basicvalue != undefined;
    },
    statusLock() {
      return categoryLabels[31][this.tracker.value > 0 ? 100 : 0];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tracker/TrackerItem.vue